import PropTypes from 'prop-types';
import { useMemo } from 'react';
import MenuLink from '../MenuLink';

import styles from './DesktopMenuLinks.module.scss';
import { MENU } from '@/constants/menu';

const PADDING_TOP = {
  PICTO_YES: '',
  PICTO_NO: 'more-padding-top'
};

const DesktopMenuLinks = ({ data, menuLevel1, onClickMenu }) => {
  const paddingTop = useMemo(() => (
    data[0].picto ? PADDING_TOP.PICTO_YES : PADDING_TOP.PICTO_NO
  ), [data]);

  return (
    <div className={`${styles['desktop-menu-links']} ${styles[paddingTop]} row mx-0`} data-test-id="desktop-menu-links">
      {data.map((link, i) => (
        <MenuLink
          key={i}
          className={`col-12 py-0 ${styles['last-no-margin-bottom']}`}
          isMobile={false}
          type={MENU.LINKS}
          link={link}
          handleClick={() => onClickMenu(menuLevel1, link.name)}
        />
      ))}
    </div>
  );
};

DesktopMenuLinks.propTypes = {
  data: PropTypes.array.isRequired,
  menuLevel1: PropTypes.string.isRequired,
  onClickMenu: PropTypes.func.isRequired
};

export default DesktopMenuLinks;
